/* tslint:disable */
/* eslint-disable */
/**
 * FreightSimple Hubble API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import type { OffsetDateTime } from "@freightsimple/time/branded-types";

import { mapValues } from "../runtime";
/**
 *
 * @export
 * @interface CarrierMeeting
 */
export interface CarrierMeeting {
  /**
   *
   * @type {string}
   * @memberof CarrierMeeting
   */
  carrierMeetingId?: string;
  /**
   *
   * @type {string}
   * @memberof CarrierMeeting
   */
  carrierIdentifier?: string;
  /**
   *
   * @type {string}
   * @memberof CarrierMeeting
   */
  jamieMeetingId?: string;
  /**
   *
   * @type {string}
   * @memberof CarrierMeeting
   */
  jamieUrl?: string;
  /**
   *
   * @type {string}
   * @memberof CarrierMeeting
   */
  title?: string;
  /**
   *
   * @type {OffsetDateTime}
   * @memberof CarrierMeeting
   */
  meetingDate?: OffsetDateTime;
  /**
   *
   * @type {string}
   * @memberof CarrierMeeting
   */
  summaryMarkdown?: string;
  /**
   *
   * @type {string}
   * @memberof CarrierMeeting
   */
  summaryShort?: string;
  /**
   *
   * @type {string}
   * @memberof CarrierMeeting
   */
  transcript?: string;
  /**
   *
   * @type {string}
   * @memberof CarrierMeeting
   */
  participantsJson?: string;
  /**
   *
   * @type {string}
   * @memberof CarrierMeeting
   */
  actionItemsJson?: string;
  /**
   *
   * @type {string}
   * @memberof CarrierMeeting
   */
  rawMeetingJson?: string;
  /**
   *
   * @type {string}
   * @memberof CarrierMeeting
   */
  notes?: string;
  /**
   *
   * @type {OffsetDateTime}
   * @memberof CarrierMeeting
   */
  createdAt?: OffsetDateTime;
  /**
   *
   * @type {string}
   * @memberof CarrierMeeting
   */
  createdBy?: string;
}

/**
 * Check if a given object implements the CarrierMeeting interface.
 */
export function instanceOfCarrierMeeting(
  value: object,
): value is CarrierMeeting {
  return true;
}

export function CarrierMeetingFromJSON(json: any): CarrierMeeting {
  return CarrierMeetingFromJSONTyped(json, false);
}

export function CarrierMeetingFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean,
): CarrierMeeting {
  if (json == null) {
    return json;
  }
  return {
    carrierMeetingId:
      json["carrierMeetingId"] == null ? undefined : json["carrierMeetingId"],
    carrierIdentifier:
      json["carrierIdentifier"] == null ? undefined : json["carrierIdentifier"],
    jamieMeetingId:
      json["jamieMeetingId"] == null ? undefined : json["jamieMeetingId"],
    jamieUrl: json["jamieUrl"] == null ? undefined : json["jamieUrl"],
    title: json["title"] == null ? undefined : json["title"],
    meetingDate: json["meetingDate"] == null ? undefined : json["meetingDate"],
    summaryMarkdown:
      json["summaryMarkdown"] == null ? undefined : json["summaryMarkdown"],
    summaryShort:
      json["summaryShort"] == null ? undefined : json["summaryShort"],
    transcript: json["transcript"] == null ? undefined : json["transcript"],
    participantsJson:
      json["participantsJson"] == null ? undefined : json["participantsJson"],
    actionItemsJson:
      json["actionItemsJson"] == null ? undefined : json["actionItemsJson"],
    rawMeetingJson:
      json["rawMeetingJson"] == null ? undefined : json["rawMeetingJson"],
    notes: json["notes"] == null ? undefined : json["notes"],
    createdAt: json["createdAt"] == null ? undefined : json["createdAt"],
    createdBy: json["createdBy"] == null ? undefined : json["createdBy"],
  };
}

export function CarrierMeetingToJSON(json: any): CarrierMeeting {
  return CarrierMeetingToJSONTyped(json, false);
}

export function CarrierMeetingToJSONTyped(
  value?: CarrierMeeting | null,
  ignoreDiscriminator: boolean = false,
): any {
  if (value == null) {
    return value;
  }

  return {
    carrierMeetingId: value["carrierMeetingId"],
    carrierIdentifier: value["carrierIdentifier"],
    jamieMeetingId: value["jamieMeetingId"],
    jamieUrl: value["jamieUrl"],
    title: value["title"],
    meetingDate: value["meetingDate"],
    summaryMarkdown: value["summaryMarkdown"],
    summaryShort: value["summaryShort"],
    transcript: value["transcript"],
    participantsJson: value["participantsJson"],
    actionItemsJson: value["actionItemsJson"],
    rawMeetingJson: value["rawMeetingJson"],
    notes: value["notes"],
    createdAt: value["createdAt"],
    createdBy: value["createdBy"],
  };
}
